import React from "react";
import { meta } from "@/lib/config";
import LayoutComplete from "@/components/templateux/layout/layout-complete";
import Terms from "@/components/content/terms";
import getServerSideSecurity from "@/lib/utils/admin/server/getServerSideSecurity";
import MD from "@/components/content/MD";
import { termscontent } from "@/components/content/terms/files/terms-2024-12-05";

export async function getServerSideProps(context) {
  //RETURN DATA FROM A FUNCTION USED BY THIS AND THE API

  //log the visit and return other relevant page / user data
  const { forbidden, user, ip, cookie, ssr_data_tribe } =
    await getServerSideSecurity(context);
  if (forbidden !== "") {
    context.res.write(forbidden);
    context.res.end();
  }

  // context.res.setHeader(
  //   'Cache-Control',
  //   'public, s-maxage=60, stale-while-revalidate=60'
  // )

  const content = await MD(termscontent(ssr_data_tribe));

  return {
    props: {
      ssr_data_tribe: ssr_data_tribe,
      content: content,
    },
  };
}

export default function ContentPage({ ssr_data_tribe, content }) {
  return (
    <>
      <LayoutComplete
        title={`${ssr_data_tribe?.brand_name} Rules`}
        url={`${ssr_data_tribe?.server_website}/en/rules`}
        image={meta(ssr_data_tribe).image}
        content={<Terms ssr_data_tribe={ssr_data_tribe} content={content} />}
        navtype={"terms"}
        ssr_data_tribe={ssr_data_tribe}
      />
    </>
  );
}
